import { ExtendedDatePicker } from '@/helpers/dateHelper';
import cn from 'classnames';
import { forwardRef, MutableRefObject, Ref } from 'react';
import { MdCalendarMonth, MdExpandMore } from 'react-icons/md';

interface DatePickerInputProps {
    label?: string;
    labelStyle?: number;
    value?: string;
    labelClassName?: string;
    className?: string;
    disabled?: boolean;
    onClick?(): void;
    parentRef?: MutableRefObject<ExtendedDatePicker | null>;
    inline?: boolean;
}

const DatePickerInput = forwardRef(
    (
        {
            label,
            labelStyle = 1,
            value,
            labelClassName,
            className,
            disabled,
            onClick,
            parentRef,
            inline = false
        }: DatePickerInputProps,
        ref: Ref<HTMLButtonElement>
    ) => {
        return (
            <div className="relative">
                {label && labelStyle === 1 && (
                    <div
                        className={cn(
                            'absolute -top-[8px] text-xs ml-2 text-brand-text px-1 bg-background',
                            labelClassName
                        )}>
                        {label}
                    </div>
                )}
                {label && labelStyle === 2 && (
                    <div className={cn('text-xs text-brand-text mb-1 bg-background', labelClassName)}>{label}</div>
                )}
                <button
                    type="button"
                    className={cn(
                        'flex items-center justify-between gap-3 border text-sm border-brand-neutral-700 hover:border-brand-neutral-600 px-2 py-1 rounded-md',
                        {
                            ['text-brand-neutral-400 cursor-not-allowed']: disabled,
                            ['text-brand-text cursor-pointer']: !disabled,
                            ['bg-brand-background']: !inline,
                            ['bg-brand-background-darkark']: inline,
                            ['h-9']: !className
                        },
                        className
                    )}
                    onClick={() => {
                        if (onClick) onClick();
                        if (parentRef) parentRef.current?.setOpen(!parentRef.current.state.open);
                    }}
                    ref={ref}>
                    <div className="flex items-center gap-3">
                        <MdCalendarMonth className="w-4 h-4" />
                        <div className="-mb-0.5">{value}</div>
                    </div>
                    <MdExpandMore className="h-4 w-4 text-brand-text" aria-hidden="true" />
                </button>
            </div>
        );
    }
);

DatePickerInput.displayName = 'DatePickerInput';

export default DatePickerInput;
